import { Type } from "class-transformer";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsNumberString, IsOptional, IsString, Matches, MaxLength, ValidateNested } from "class-validator";
import { ShiftsEnum } from "@gtpl/shared-models/common-models";
import { PeelingSamplesDto } from "./pelling-samples.dto";

export class PeelingDto {
    @ApiProperty()
    peelingId:number;
    @ApiProperty()
    peelingDate:Date;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    saleOrderItemId:number;
    @ApiProperty()
    lotNumber:string
    @ApiProperty()
    shift:ShiftsEnum;
    @ApiProperty()
    isActive: boolean;
    createdAt: Date;
    @ApiProperty()
    createdUser: string;
    updatedAt: Date;
    @ApiProperty()
     updatedUser: string;
    versionFlag: number;

    @ApiProperty({ type: [PeelingSamplesDto] })
    peelingSamplesInfo: PeelingSamplesDto[];
   
}